import type { SubscriptionPlan } from '../types/payment.types';

export const fallbackOfferings: SubscriptionPlan[] = [
    {
        price: 12,
        currency: 'nzd',
        minorUnitDigits: 2,
        locale: 'en-NZ',
        unitAmount: 1200,
        recurringInterval: 'month',
        recurringIntervalCount: 1,
        duration: '1 Month',
        descriptors: [
            'Affordable monthly fee',
            'Unlimited catalogue access',
            'Cancel anytime'
        ],
        offeringId: 'monthly',
        planCode: 'monthly',
        marketCode: 'NZ',
        badge: 'Flexible',
        tagline: 'Stream month-to-month with total freedom.'
    },
    {
        price: 100,
        currency: 'nzd',
        minorUnitDigits: 2,
        locale: 'en-NZ',
        unitAmount: 10000,
        recurringInterval: 'year',
        recurringIntervalCount: 1,
        duration: '1 Year',
        descriptors: [
            'Save 30% with annual pricing',
            'Billed annually',
            'Unlimited catalogue access'
        ],
        offeringId: 'yearly',
        planCode: 'yearly',
        marketCode: 'NZ',
        badge: 'Best value',
        tagline: 'Lock in the lowest rate for the full year.',
        isFeatured: true
    }
];

export const sanitizePlans = (plans: SubscriptionPlan[]) =>
    plans
        .map((plan) => ({
            ...plan,
            descriptors: Array.isArray(plan.descriptors) ? plan.descriptors : []
        }))
        .filter((plan) => (
            plan.offeringId
            && plan.duration
            && Number.isFinite(plan.price)
            && plan.price >= 0
            && !!plan.currency
            && Number.isInteger(plan.minorUnitDigits)
            && plan.minorUnitDigits >= 0
            && plan.minorUnitDigits <= 3
            && !!plan.locale
            && !!plan.planCode
            && !!plan.marketCode
            && Number.isSafeInteger(plan.unitAmount)
            && plan.unitAmount >= 0
            && Math.round(plan.price * (10 ** plan.minorUnitDigits)) === plan.unitAmount
            && !!plan.recurringInterval
            && Number.isSafeInteger(plan.recurringIntervalCount)
            && plan.recurringIntervalCount > 0
        ));

export const formatSubscriptionPrice = (plan: SubscriptionPlan): string => {
    try {
        return new Intl.NumberFormat(plan.locale || undefined, {
            style: 'currency',
            currency: plan.currency.toUpperCase(),
            maximumFractionDigits: plan.price % 1 === 0 ? 0 : plan.minorUnitDigits
        }).format(plan.price);
    } catch {
        return `${plan.currency.toUpperCase()} ${plan.price}`;
    }
};
